<template>
  <v-banner v-if="showBanner" id="cookie-consent-banner">
    <v-banner-text>
      <p>
        Turpinot lietot šo vietni, Jūs piekrītat sīkdatņu lietošanai!
      </p>
      <p>
        <a href="/sikdatnu-politika" target="_blank">Sīkdatņu politika</a>
      </p>
    </v-banner-text>

    <template v-slot:actions>
      <v-btn

        @click.stop.prevent="consentRequired"
      >
        Atslēgt statistikas sīkdatnes
      </v-btn>
      <v-btn
        variant="flat"
        class="btn-subjects ml-2 bg-yellowActive text-blackActive font-weight-bold"
        @click.stop.prevent="consentAll"
      >
        Turpināt
      </v-btn>
      <v-btn
        class="close"
        icon="fa-solid fa-close"
        variant="plain"
        @click="closed = true"
      ></v-btn>
    </template>

  </v-banner>
</template>

<script lang="ts">
import { useCookieConsentUpdate } from "~/composables/useCookieConsentUpdate"
import storage from "~/services/storage"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    return {
      userStore,
    }
  },

  data() {
    return {
      closed: false,
    }
  },

  computed: {
    mustConsent() {
      return this.userStore.current && this.userStore.current.cookie_consent === null
    },

    showBanner() {
      return (!this.closed && this.mustConsent) ||
      (!this.userStore?.current && !storage.getCookieConsent())
    }
  },

  methods: {
    consentAll() {
      storage.setCookieConsent("all")
      if (!this.userStore?.current) {
        useCookieConsentUpdate()
      } else {
        this.userStore.updateCookieConsent({
          cookieConsent: "all",
          successCallback: useCookieConsentUpdate,
        })
      }
      this.closed = true
    },

    consentRequired() {
      storage.setCookieConsent("required")
      if (!this.userStore?.current) {
        useCookieConsentUpdate()
      } else {
        this.userStore.updateCookieConsent({
          cookieConsent: "required",
          successCallback: useCookieConsentUpdate,
        })
      }
      this.closed = true
    },
  },
}
</script>

<style lang="sass" scoped>
#cookie-consent-banner
  position: fixed
  bottom: 0
  z-index: 10000
  background-color: #FDF7E5
  justify-content: center

  .v-banner-text
    a
      color: black

  .v-btn
    text-transform: none

    &.close
      position: absolute
      top: 2px
      right: 2px

</style>
